export const SET_PLATFORM_SETTINGS = 'SET_PLATFORM_SETTINGS';
export const SET_TABLE_PAGE_SIZE = 'SET_TABLE_PAGE_SIZE';

export const TRIGGER_SUPER_USER = 'TRIGGER_SUPER_USER';

export const INITIALIZE_REDUX_STATE = 'INITIALIZE_REDUX_STATE';
